import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";

function VersionModal({ versionData, onClose }) {
  const dialogRef = useRef(null);

  // Open dialog when component mounts
  useEffect(() => {
    if (dialogRef.current && !dialogRef.current.open) {
      dialogRef.current.showModal();
    }
  }, []);

  return (
    <dialog
      ref={dialogRef}
      className="version-modal"
      onCancel={onClose}
    >
      <h2>Version Information</h2>

      <pre>{JSON.stringify(versionData, null, 2)}</pre>

      <button type="button" onClick={onClose}>
        Close
      </button>
    </dialog>
  );
}

VersionModal.propTypes = {
  versionData: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
    PropTypes.string,
    PropTypes.number,
  ]),
  onClose: PropTypes.func.isRequired,
};

VersionModal.defaultProps = {
  versionData: null,
};

export default VersionModal;
